import { useTranslation } from 'react-i18next'
import Hero from '../sections/Hero'
import Services from '../sections/PricingPlans'
import Projects from '../sections/CaseStudies'
import Partners from '../sections/Partners'
import ContactForm from '../sections/ContactForm'

export default function Home() {
  const { t } = useTranslation()
  return (
    <div id="top">
      <Hero />

      {/* Divider line */}
      <div className="h-px bg-gradient-to-r from-transparent via-white/5 to-transparent mx-6" />

      {/* Services */}
      <Services />

      {/* Divider line */}
      <div className="h-px bg-gradient-to-r from-transparent via-white/5 to-transparent mx-6" />

      {/* Projects */}
      <Projects />

      {/* Divider line */}
      <div className="h-px bg-gradient-to-r from-transparent via-white/5 to-transparent mx-6" />

      {/* Partners */}
      <Partners />

      {/* Divider line */}
      <div className="h-px bg-gradient-to-r from-transparent via-white/5 to-transparent mx-6" />

      {/* About */}
      <section id="about" className="relative py-24 px-6">
        <div className="max-w-3xl mx-auto text-center">
          <span className="text-xs uppercase tracking-widest text-indigo-400 font-medium">{t('about.headline')}</span>
          <h2 className="text-4xl md:text-5xl mt-3 mb-6">{t('about.headline')}</h2>
          <p className="text-lg text-slate-100/80 leading-relaxed">{t('about.text')}</p>
        </div>
      </section>

      {/* Divider line */}
      <div className="h-px bg-gradient-to-r from-transparent via-white/5 to-transparent mx-6" />

      {/* Contact */}
      <section id="contact" className="relative py-24 px-6">
        {/* Glow */}
        <div aria-hidden className="pointer-events-none absolute inset-0 -z-10">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[300px] rounded-full bg-blue-300/20 blur-[100px]" />
        </div>
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <span className="text-xs uppercase tracking-widest text-indigo-400 font-medium">{t('contact.headline')}</span>
            <h2 className="text-4xl md:text-5xl mt-3 mb-3">{t('contact.headline')}</h2>
            <p className="text-slate-100/80">{t('contact.subheadline')}</p>
          </div>
          <div className="rounded-2xl border border-white/15 p-8 md:p-10" style={{ background: 'linear-gradient(145deg, rgba(52, 74, 132, 0.92), rgba(35, 54, 102, 0.88))' }}>
            <ContactForm />
          </div>
        </div>
      </section>
    </div>
  )
}